import { IDataAction } from "@shared/interfaces/data-action.interface";
import { IDataColumn } from "@shared/interfaces/data-column.interface";
import { ITableDescriptor } from "@shared/interfaces/table-descriptor.interface";
import { format, parse, parseISO } from "date-fns";
import { es } from "date-fns/locale";



export class TableDescriptor implements ITableDescriptor {

  private datacolumns: IDataColumn[] = [
    {
      field: 'date',
      value: 'Fecha',
      filterOrder: 3,
      fn: (date: any) => {
        const parsedDate = parse(date, 'dd-MM-yyyy', new Date());
        if (isNaN(parsedDate.getTime())) {
          return 'Fecha no válida';
        }
        return format(parsedDate, 'EEEE dd/MM/yyyy', { locale: es })
      }
    },
    {
      field: 'hour',
      value: 'Hora',
      filterOrder: 3,
      fn: (hour: string) => {
        return hour;
      }
    },
    {
      field: 'service_profile',
      value: 'Actividad',
      filterOrder: 2,
      // isComplex: true,
      fn: (service_profile: any) => {
        let $text_to_show = `${service_profile.service.name} - ${service_profile.name}`;
        return $text_to_show;
      }
    },
    {
      field: 'booking.customer.name',
      value: 'Nombre',
      isComplex: true,
      fn: (name: string) => {
        return name;
      }
    },
    {
      field: 'booking.reference',
      value: 'Ref.',
      isComplex: true,
      fn: (reference: number) => {
        return reference;
      }
    },
    {
      field: 'booking.status.status',
      value: 'Estado',
      isComplex: true,
      alignment: 'text-center',
      fnLabelColor(status_booking: any) {
        switch (status_booking) {
          case 'Pendiente de Pago':
            return 'warning';
          case 'PAGADA':
            return 'info';
          case 'FINALIZADA':
            return 'success';
          case 'ANULADA':
            return 'danger';
          default:
            return 'secondary';
        }
      },
      fn: (status_booking: string) => {
        return status_booking;
      }
    },
  ];

  private globalFilters: Array<string> = ['office', 'date', 'service', 'seats'];

  private dataactions: IDataAction[] = [
    {
      action: 'insight',
      icon: 'pi pi-eye',
      colorClass: 'p-button-dark',
      tooltipText: 'Ver detalle de reserva',
      label: 'Consultar',
      condition: (element: any) => {
        return true;
      }
    },
  ];


  constructor() { }

  getGlobalFilters(): Array<string> {
    return this.globalFilters;
  }

  getColumns(): IDataColumn[] {
    return this.datacolumns;
  }

  getActions(): IDataAction[] {
    return this.dataactions;
  }

}
